import type { WeightedSecurity } from '@fruitful/types';

import { requestBuilder } from '../../http/RequestBuilder';

export const useGetApexPositions = (
    accountId: string,
    enabled: boolean = false,
) => {
    return useGetPositions(
        {
            accountId,
        },
        {
            enabled,
        },
    );
};

const useGetPositions = requestBuilder.query<
    WeightedSecurity[],
    { accountId: string }
>({
    endpoint: ({ accountId }) => `/api/investments/${accountId}/positions`,
    queryKey: ({ accountId }) => `/api/investments/${accountId}/positions`,
});
